<div class="menu-container">
    <app-menu-option
        *ngFor="let configuration of configurationCollection"
        [configuration]="configuration"
        [showIcon]="true"
    ></app-menu-option>
</div>
